"use client"

import Image from "next/image"

/** flagcdn only serves specific WxH pairs — invalid sizes return empty image */
const FLAGCDN_SIZES = [
  [16, 12],
  [20, 15],
  [32, 24],
  [40, 30],
  [48, 36],
  [64, 48],
  [80, 60],
  [160, 120],
  [320, 240]
] as const

const nearestFlagSize = (width: number, height: number) => {
  let best = FLAGCDN_SIZES[0]
  let bestScore = Infinity
  for (const size of FLAGCDN_SIZES) {
    const score =
      Math.abs(size[0] - width) + Math.abs(size[1] - height)
    if (score < bestScore) {
      best = size
      bestScore = score
    }
  }
  return best
}

const FlagComponent = ({
  code,
  width = 16,
  height = 12
}: {
  code: string
  width?: number
  height?: number
}) => {
  const [w, h] = nearestFlagSize(width, height)
  const flagSrc = `https://flagcdn.com/${w}x${h}/${code}.png`

  return (
    <Image
      src={flagSrc}
      alt={`${code} flag`}
      width={w}
      height={h}
      unoptimized
    />
  )
}

export default FlagComponent
